// ============================================
// LE COMPTOIR DU COFFRET - Shopify Theme JS
// ============================================

// Préfixe locale (ex. /en/) pour les appels AJAX cart/produits,
// sinon Shopify renvoie les données dans la langue par défaut.
function lpUrl(path) {
  let root = (window.themeRoutes && window.themeRoutes.root) || '/';
  if (!root.endsWith('/')) root += '/';
  return root + path;
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initSearch();
  initCart();
  initScrollAnimations();
  initQuickView();
  initProductForms();
  initProductPage();

  // Update cart count on load
  fetchCartAndUpdate();
});

// ===================
// HEADER & NAVIGATION
// ===================

function initHeader() {
  const header = document.getElementById('header');

  // Scroll effect
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
  });

  // Mobile menu elements
  const mobileBtn = document.getElementById('mobileMenuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
  const mobileMenuClose = document.getElementById('mobileMenuClose');

  // Open mobile menu
  function openMobileMenu() {
    mobileMenu?.classList.add('active');
    mobileMenuOverlay?.classList.add('active');
    mobileBtn?.classList.add('active');
    document.body.classList.add('menu-open');
  }

  // Close mobile menu
  function closeMobileMenu() {
    mobileMenu?.classList.remove('active');
    mobileMenuOverlay?.classList.remove('active');
    mobileBtn?.classList.remove('active');
    document.body.classList.remove('menu-open');
  }

  // Event listeners
  mobileBtn?.addEventListener('click', openMobileMenu);
  mobileMenuClose?.addEventListener('click', closeMobileMenu);
  mobileMenuOverlay?.addEventListener('click', closeMobileMenu);

  // Close menu on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu?.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  // Submenu toggles
  const submenuToggles = document.querySelectorAll('.submenu-toggle');
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const parentItem = toggle.closest('.has-submenu');
      const submenu = parentItem?.querySelector('.mobile-submenu');

      // Close other open submenus
      document.querySelectorAll('.submenu-toggle.open').forEach(otherToggle => {
        if (otherToggle !== toggle) {
          otherToggle.classList.remove('open');
          otherToggle.closest('.has-submenu')?.querySelector('.mobile-submenu')?.classList.remove('open');
        }
      });

      // Toggle current submenu
      toggle.classList.toggle('open');
      submenu?.classList.toggle('open');
    });
  });

  // Close menu when clicking on a link (except submenu toggles)
  const menuLinks = mobileMenu?.querySelectorAll('a');
  menuLinks?.forEach(link => {
    link.addEventListener('click', () => {
      closeMobileMenu();
    });
  });
}

// ===================
// SEARCH FUNCTIONALITY
// ===================

function initSearch() {
  const searchBtn = document.querySelector('.search-btn');
  const searchModal = document.getElementById('searchModal');
  const closeSearch = document.querySelector('.close-search');
  const searchInput = document.getElementById('searchInput');

  if (searchBtn && searchModal) {
    // Open search modal
    searchBtn.addEventListener('click', () => {
      searchModal.classList.add('active');
      searchInput?.focus();
    });

    // Close search modal
    closeSearch?.addEventListener('click', () => {
      searchModal.classList.remove('active');
    });

    // Close on overlay click
    searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        searchModal.classList.remove('active');
      }
    });

    // Predictive search with Shopify API
    searchInput?.addEventListener('input', debounce((e) => {
      const query = e.target.value.trim();
      if (query.length > 2) {
        fetchPredictiveSearch(query);
      }
    }, 300));
  }
}

function fetchPredictiveSearch(query) {
  fetch(lpUrl(`search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`))
    .then(res => res.json())
    .then(data => {
      renderSearchResults(data.resources.results.products);
    })
    .catch(err => console.error('Search error:', err));
}

function renderSearchResults(products) {
  const resultsContainer = document.getElementById('searchResults');
  if (!resultsContainer) return;

  if (products.length === 0) {
    resultsContainer.innerHTML = `<p class="no-results">${(window.themeI18n?.noResults) || 'Aucun résultat'}</p>`;
    return;
  }

  resultsContainer.innerHTML = products.map(product => `
    <a href="${product.url}" class="search-result-item">
      <img src="${product.image}" alt="${product.title}" loading="lazy">
      <div>
        <h4>${product.title}</h4>
        <p class="price">${formatMoney(product.price)}</p>
      </div>
    </a>
  `).join('');
}

// ===================
// CART MANAGEMENT (Shopify API)
// ===================

function initCart() {
  // Cart button interactions
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form[action$="/cart/add"]');
      if (form) {
        addToCart(form);
      }
    });
  });
}

function initProductForms() {
  // Handle all product forms
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  });
}

function addToCart(form) {
  const formData = new FormData(form);
  const button = form.querySelector('button[type="submit"]');

  if (button) button.disabled = true;

  // Open drawer instantly with whatever was already cached.
  // The slide-in animation runs in parallel with the network request.
  openCartDrawer();
  setCartDrawerLoading(true);

  fetch(lpUrl('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || 1)
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Erreur ajout panier');
    return res.json();
  })
  .then(() => {
    closeQuickView();
    return fetchCartAndUpdate(false); // drawer already open, just refresh contents
  })
  .then(() => {
    // Scroll to top so the freshly added line is visible
    const body = document.querySelector('#cartDrawer [data-cart-body]');
    if (body) body.scrollTop = 0;
  })
  .catch(err => {
    console.error('Add to cart error:', err);
    closeCartDrawer();
    showToast((window.themeI18n?.cartError) || 'Erreur lors de l\'ajout au panier', 'error');
  })
  .finally(() => {
    setCartDrawerLoading(false);
    if (button) button.disabled = false;
  });
}

function setCartDrawerLoading(on) {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  drawer.classList.toggle('is-loading', !!on);
}

function fetchCartAndUpdate(openDrawer) {
  return fetch(lpUrl('cart.js'))
    .then(res => res.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      if (openDrawer) openCartDrawer();
      return cart;
    })
    .catch(err => console.error('Fetch cart error:', err));
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function updateCartItemQuantity(key, quantity) {
  fetch(lpUrl('cart/change.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
    // Reload cart page if we're on it
    if (document.querySelector('.cart-page')) {
      location.reload();
    }
  })
  .catch(err => console.error('Update cart error:', err));
}

function removeFromCart(key) {
  updateCartItemQuantity(key, 0);
}

// ===================
// QUICK VIEW MODAL
// ===================

let currentQuickViewProduct = null;

function initQuickView() {
  // Add event listeners to quick view buttons
  document.querySelectorAll('.quick-view-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.dataset.handle || btn.dataset.productHandle;
      if (handle) {
        openQuickView(handle);
      }
    });
  });

  // Close modal handlers
  const modal = document.getElementById('quickViewModal');
  const closeBtn = modal?.querySelector('.modal-close');
  const overlay = modal?.querySelector('.modal-overlay');

  closeBtn?.addEventListener('click', closeQuickView);
  overlay?.addEventListener('click', closeQuickView);
}

function openQuickView(productHandle) {
  const modal = document.getElementById('quickViewModal');
  const content = document.getElementById('quickViewContent');

  if (!modal || !content) return;

  // Show loading
  content.innerHTML = `<div class="loading">${(window.themeI18n?.loading) || 'Chargement...'}</div>`;
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';

  // Fetch product data
  fetch(lpUrl(`products/${productHandle}.js`))
    .then(res => res.json())
    .then(product => {
      currentQuickViewProduct = product;
      renderQuickViewContent(product);
    })
    .catch(err => {
      console.error('Quick view error:', err);
      content.innerHTML = `<p class="error">${(window.themeI18n?.loadError) || 'Erreur de chargement'}</p>`;
    });
}

function renderQuickViewContent(product) {
  const content = document.getElementById('quickViewContent');
  if (!content) return;

  const firstVariant = product.variants[0];
  const price = formatMoney(firstVariant.price);
  const comparePrice = firstVariant.compare_at_price ? formatMoney(firstVariant.compare_at_price) : null;

  content.innerHTML = `
    <div class="quick-view-grid">
      <div class="quick-view-image">
        <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
      </div>
      <div class="quick-view-info">
        <h2>${product.title}</h2>
        <div class="price-wrapper">
          ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
          <span class="price">${price}</span>
        </div>
        <div class="description">
          ${product.description || ''}
        </div>

        <form action="${lpUrl('cart/add')}" method="post" id="quickViewForm">
          <input type="hidden" name="id" value="${firstVariant.id}">

          ${product.variants.length > 1 ? renderVariantSelector(product) : ''}

          <div class="quantity-selector">
            <label for="quick-quantity">${(window.themeI18n?.quantity) || 'Quantité'}</label>
            <input type="number" name="quantity" id="quick-quantity" value="1" min="1">
          </div>

          <button type="submit" class="btn btn-primary add-to-cart-btn" ${!firstVariant.available ? 'disabled' : ''}>
            ${firstVariant.available ? ((window.themeI18n?.addToCart) || 'Ajouter au panier') : ((window.themeI18n?.soldOut) || 'Épuisé')}
          </button>
        </form>

        <a href="${product.url}" class="view-full-details">${(window.themeI18n?.viewDetails) || 'Voir tous les détails →'}</a>
      </div>
    </div>
  `;

  // Re-init form handlers for quick view
  const form = document.getElementById('quickViewForm');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  }
}

function renderVariantSelector(product) {
  if (product.variants.length <= 1) return '';

  return `
    <div class="variant-selector">
      <label for="quick-variant">Option</label>
      <select name="id" id="quick-variant">
        ${product.variants.map(variant => `
          <option value="${variant.id}" ${!variant.available ? 'disabled' : ''}>
            ${variant.title} - ${formatMoney(variant.price)} ${!variant.available ? '(Épuisé)' : ''}
          </option>
        `).join('')}
      </select>
    </div>
  `;
}

function closeQuickView() {
  const modal = document.getElementById('quickViewModal');
  modal?.classList.remove('active');
  document.body.style.overflow = '';
  currentQuickViewProduct = null;
}

// ===================
// SCROLL ANIMATIONS
// ===================

function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');

  if (!animatedElements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  animatedElements.forEach(el => observer.observe(el));
}

// ===================
// FAQ ACCORDION
// ===================

function initFAQ() {
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.parentElement;
      const wasActive = item.classList.contains('active');

      // Close all
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));

      // Toggle current
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });
}

// ===================
// TOAST NOTIFICATIONS
// ===================

function showToast(message, type = 'success') {
  const toast = document.getElementById('toast');
  const toastMessage = toast?.querySelector('.toast-message');

  if (toast && toastMessage) {
    toastMessage.textContent = message;
    toast.classList.add('show');
    toast.classList.toggle('error', type === 'error');

    setTimeout(() => {
      toast.classList.remove('show');
      toast.classList.remove('error');
    }, 3000);
  }
}

// ===================
// UTILITY FUNCTIONS
// ===================

function formatMoney(cents) {
  const amount = cents / 100;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// ===================
// PRODUCT PAGE SPECIFIC
// ===================

function initProductPage() {
  // Thumbnail switching - use event delegation for better reliability
  const thumbnailsContainer = document.querySelector('.thumbnails');
  if (thumbnailsContainer) {
    thumbnailsContainer.addEventListener('click', (e) => {
      const thumb = e.target.closest('.thumbnail');
      if (!thumb) return;

      const mainImage = document.querySelector('.product-main-img');
      const imageUrl = thumb.getAttribute('data-image-url');

      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;

        // Update active thumbnail
        thumbnailsContainer.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  }
}

// ===================
// COOKIE CONSENT
// ===================

function initCookieConsent() {
  const banner = document.getElementById('cookieBanner');
  const modal = document.getElementById('cookieModal');
  const acceptBtn = document.getElementById('cookieAccept');
  const settingsBtn = document.getElementById('cookieSettings');
  const modalClose = document.getElementById('cookieModalClose');
  const modalOverlay = document.getElementById('cookieModalOverlay');
  const rejectAllBtn = document.getElementById('cookieRejectAll');
  const saveSettingsBtn = document.getElementById('cookieSaveSettings');
  const analyticsCheckbox = document.getElementById('cookieAnalytics');
  const marketingCheckbox = document.getElementById('cookieMarketing');

  // Check if consent already given
  const consent = localStorage.getItem('cookieConsent');

  if (!consent && banner) {
    // Show banner after a short delay
    setTimeout(() => {
      banner.classList.add('show');
    }, 1000);
  }

  // Accept all cookies
  acceptBtn?.addEventListener('click', () => {
    saveCookiePreferences({ essential: true, analytics: true, marketing: true });
    closeCookieBanner();
  });

  // Open settings modal
  settingsBtn?.addEventListener('click', () => {
    modal?.classList.add('show');
    document.body.style.overflow = 'hidden';
  });

  // Close modal
  function closeModal() {
    modal?.classList.remove('show');
    document.body.style.overflow = '';
  }

  modalClose?.addEventListener('click', closeModal);
  modalOverlay?.addEventListener('click', closeModal);

  // Reject all (keep only essential)
  rejectAllBtn?.addEventListener('click', () => {
    if (analyticsCheckbox) analyticsCheckbox.checked = false;
    if (marketingCheckbox) marketingCheckbox.checked = false;
    saveCookiePreferences({ essential: true, analytics: false, marketing: false });
    closeModal();
    closeCookieBanner();
  });

  // Save custom settings
  saveSettingsBtn?.addEventListener('click', () => {
    saveCookiePreferences({
      essential: true,
      analytics: analyticsCheckbox?.checked || false,
      marketing: marketingCheckbox?.checked || false
    });
    closeModal();
    closeCookieBanner();
  });

  function saveCookiePreferences(preferences) {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());

    // Here you can add logic to enable/disable tracking scripts
    // based on user preferences
    if (preferences.analytics) {
      // Enable analytics
      console.log('Analytics cookies enabled');
    }
    if (preferences.marketing) {
      // Enable marketing
      console.log('Marketing cookies enabled');
    }
  }

  function closeCookieBanner() {
    banner?.classList.remove('show');
    setTimeout(() => {
      banner?.remove();
    }, 500);
  }
}

// Initialize cookie consent on load
document.addEventListener('DOMContentLoaded', initCookieConsent);

// ===================
// CART DRAWER (slide-in from right)
// ===================

function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Nettoie le titre de variante pour l'affichage client (n'altère PAS les données) :
// - masque l'origine d'expédition (China Mainland, GERMANY, france…)
// - masque les dimensions brutes (ex. 16.5X11.5X8.5cm) déjà présentes dans le titre produit
// - traduit les libellés anglais (6 Slots -> 6 emplacements)
function cleanVariantTitle(title) {
  if (!title) return '';
  var hide = ['china mainland', 'china', 'mainland china', 'germany', 'allemagne',
              'france', 'spain', 'espagne', 'united states', 'usa', 'czech republic',
              'poland', 'belgium', 'italy', 'turkey'];
  return String(title)
    .split(' / ')
    .map(function (seg) { return seg.trim(); })
    .filter(function (seg) {
      var low = seg.toLowerCase();
      if (hide.indexOf(low) !== -1) return false; // origine
      if (/^[\d.,]+\s*[x×]\s*[\d.,]+(\s*[x×]\s*[\d.,]+)?\s*cm$/i.test(seg)) return false; // dimension brute
      return true;
    })
    .map(function (seg) {
      return seg
        .replace(/(\d+)\s*slots?/ig, '$1 emplacements')
        .replace(/(\d+)\s*positions?/ig, '$1 emplacements')
        .replace(/(\d+)\s*(?:grids?|girds?)/ig, '$1 emplacements')
        .replace(/\bslots?\b/ig, 'emplacements')
        .replace(/\bpositions?\b/ig, 'emplacements');
    })
    .join(' / ')
    .trim();
}

function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  // Measure scrollbar BEFORE locking — once we set overflow:hidden, it disappears.
  const sbw = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  if (sbw > 0) {
    document.body.style.paddingRight = sbw + 'px';
    document.documentElement.style.setProperty('--scrollbar-comp', sbw + 'px');
  }
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  document.documentElement.style.removeProperty('--scrollbar-comp');
}

function renderCartDrawer(cart) {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer || !cart) return;

  const body = drawer.querySelector('[data-cart-body]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const empty = drawer.querySelector('[data-cart-empty]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');
  const countEl = drawer.querySelector('[data-cart-count]');

  if (countEl) countEl.textContent = cart.item_count;

  if (cart.item_count === 0) {
    body.innerHTML = '';
    body.hidden = true;
    footer.hidden = true;
    empty.hidden = false;
    return;
  }

  body.hidden = false;
  empty.hidden = true;
  footer.hidden = false;
  subtotal.textContent = formatMoney(cart.total_price);

  body.innerHTML = cart.items.map(item => {
    const cleanVar = cleanVariantTitle(item.variant_title);
    const variant = (cleanVar && item.variant_title !== 'Default Title')
      ? `<div class="cart-drawer-item-variant">${escapeHtml(cleanVar)}</div>` : '';
    const img = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
    return `
      <article class="cart-drawer-item" data-key="${escapeHtml(item.key)}" data-unit-price="${item.final_price}">
        <a href="${escapeHtml(item.url)}" class="cart-drawer-item-img">${img}</a>
        <div class="cart-drawer-item-info">
          <a href="${escapeHtml(item.url)}" class="cart-drawer-item-title">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="cart-drawer-item-row">
            <div class="cart-drawer-qty">
              <button type="button" data-qty-delta="-1" aria-label="Réduire">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-delta="1" aria-label="Augmenter">+</button>
            </div>
            <span class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
        <button type="button" class="cart-drawer-item-remove" data-cart-remove aria-label="Retirer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </article>`;
  }).join('');
}

// --- Optimistic update helpers (responsive +/− and remove) ---

const cartUpdateTimers = new Map();

function parseMoneyToCents(text) {
  if (!text) return 0;
  const cleaned = String(text).replace(/[^\d,.-]/g, '').replace(',', '.');
  return Math.round(parseFloat(cleaned || '0') * 100);
}

function bumpBadge(el, delta) {
  if (!el) return;
  const current = parseInt(el.textContent, 10) || 0;
  el.textContent = Math.max(0, current + delta);
}

function optimisticAdjustItem(item, nextQty) {
  const drawer = document.getElementById('cartDrawer');
  const span = item.querySelector('.cart-drawer-qty span');
  const priceEl = item.querySelector('.cart-drawer-item-price');
  const unitPrice = parseInt(item.dataset.unitPrice, 10) || 0;
  const currentQty = parseInt(span.textContent, 10) || 0;
  const qtyDelta = nextQty - currentQty;

  if (nextQty === 0) {
    // Smooth collapse, then remove from DOM
    const h = item.scrollHeight;
    item.style.maxHeight = h + 'px';
    item.style.overflow = 'hidden';
    item.style.transition = 'opacity 0.18s ease, max-height 0.22s ease, padding 0.22s ease, margin 0.22s ease, border 0.22s ease';
    requestAnimationFrame(() => {
      item.style.opacity = '0';
      item.style.maxHeight = '0px';
      item.style.paddingTop = '0';
      item.style.paddingBottom = '0';
      item.style.marginTop = '0';
      item.style.marginBottom = '0';
      item.style.borderWidth = '0';
    });
    setTimeout(() => { item.remove(); }, 230);
  } else {
    span.textContent = nextQty;
    if (priceEl) priceEl.textContent = formatMoney(unitPrice * nextQty);
  }

  // Update subtotal + badges instantly
  if (drawer) {
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) {
      const next = Math.max(0, parseMoneyToCents(subtotalEl.textContent) + qtyDelta * unitPrice);
      subtotalEl.textContent = formatMoney(next);
    }
    bumpBadge(drawer.querySelector('[data-cart-count]'), qtyDelta);
  }
  document.querySelectorAll('.cart-count, .mobile-cart-badge').forEach(el => bumpBadge(el, qtyDelta));
}

function debouncedCartChange(key, qty) {
  const existing = cartUpdateTimers.get(key);
  if (existing) clearTimeout(existing);

  const timer = setTimeout(() => {
    cartUpdateTimers.delete(key);
    fetch(lpUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(res => res.json())
    .then(cart => {
      // Reconcile silently: only sync subtotal + badge counts.
      // We don't re-render the items list — that would lose scroll position
      // and undo the optimistic UI the user is seeing.
      updateCartCount(cart.item_count);
      const drawer = document.getElementById('cartDrawer');
      if (drawer) {
        const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
        const countEl = drawer.querySelector('[data-cart-count]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (countEl) countEl.textContent = cart.item_count;
        if (cart.item_count === 0) renderCartDrawer(cart);
      }
      if (document.querySelector('.cart-page')) location.reload();
    })
    .catch(err => {
      console.error('Cart change error:', err);
      // On failure, resync from server so UI matches reality
      fetchCartAndUpdate(false);
    });
  }, 280);

  cartUpdateTimers.set(key, timer);
}

function initCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  // Close: overlay, close button, ESC
  drawer.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', closeCartDrawer);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
  });

  // Quantity adjust + remove — optimistic UI, debounced network call
  const body = drawer.querySelector('[data-cart-body]');
  body.addEventListener('click', e => {
    const item = e.target.closest('.cart-drawer-item');
    if (!item) return;
    const key = item.dataset.key;

    const qtyBtn = e.target.closest('[data-qty-delta]');
    if (qtyBtn) {
      const span = item.querySelector('.cart-drawer-qty span');
      const current = parseInt(span.textContent, 10) || 0;
      const delta = parseInt(qtyBtn.dataset.qtyDelta, 10);
      const next = Math.max(0, current + delta);
      if (next === current) return;
      optimisticAdjustItem(item, next);
      debouncedCartChange(key, next);
      return;
    }

    if (e.target.closest('[data-cart-remove]')) {
      optimisticAdjustItem(item, 0);
      debouncedCartChange(key, 0);
    }
  });

  // Cart icon clicks (header desktop + mobile) → open drawer
  document.querySelectorAll('.cart-btn, .mobile-action-btn.cart').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Initial render
  fetchCartAndUpdate(false);
}

document.addEventListener('DOMContentLoaded', initCartDrawer);

// Make functions available globally
window.shopifyTheme = {
  addToCart,
  updateCartItemQuantity,
  removeFromCart,
  openQuickView,
  closeQuickView,
  showToast,
  formatMoney,
  openCartDrawer,
  closeCartDrawer,
  renderCartDrawer
};
